import { Popover, Menu, Disclosure } from "@headlessui/react";
import { NavLink } from "react-router-dom";
import { Helmet } from "react-helmet";
import {
  MenuIcon,
  XIcon,
  ChevronDownIcon,
  SearchIcon,
} from "@heroicons/react/outline";
import logo from "../../assets/logo.png";
import { useState } from "react";

const navigation = [
  {
    name: "AI",
    href: "/ai",
    submenu: [
      { name: "ChatGPT", href: "/ai/chatgpt" },
      { name: "Image", href: "/ai/image" },
    ],
  },
  {
    name: "Services",
    href: "/services",
    submenu: [
      { name: "Web Development", href: "/services/web-development" },
      { name: "SEO", href: "/services/seo" },
    ],
  },
  { name: "About Us", href: "/about-us" },
  { name: "Blog", href: "/blog" },
  { name: "Contact", href: "/contact" },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

function Navbar() {
  const [search, setSearch] = useState("");

  return (
    <>
      <Helmet>
        <title>YourVirtualOffice</title>
        <meta name="description" content="Home Page - YourVirtualOffice" />
      </Helmet>

      <Popover as="header" className="bg-white border-b border-gray-200">
        {({ open }) => (
          <>
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between">
              <NavLink to="/">
                <img
                  src={logo}
                  width={50}
                  height={50}
                  alt="Logo"
                  className="block"
                />
              </NavLink>
              <div className="hidden lg:flex lg:items-center">
                {" "}
                {navigation.map((item) => (
                  <NavLink
                    key={item.name}
                    to={item.href}
                    className="mx-4 text-lg font-semibold text-gray-600 hover:text-blue-600"
                  >
                    {" "}
                    {item.name}{" "}
                  </NavLink>
                ))}{" "}
                <NavLink
                  to="/get-started"
                  className="ml-4 px-6 py-2 rounded-full text-white bg-blue-800 hover:bg-blue-900"
                >
                  {" "}
                  Get Started{" "}
                </NavLink>{" "}
              </div>
              <div className="lg:hidden flex items-center w-full">
                <div className="relative flex-grow">
                  <input
                    type="text"
                    className="pl-8 pr-3 py-2 border rounded-full w-full text-sm text-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Search..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                  <SearchIcon className="absolute left-2 top-2 h-5 w-5 text-gray-500" />
                </div>
                <Popover.Button className="p-2 rounded-md text-gray-400 hover:bg-gray-100 hover:text-gray-500">
                  {open ? (
                    <XIcon className="h-6 w-6" />
                  ) : (
                    <MenuIcon className="h-6 w-6" />
                  )}
                </Popover.Button>
              </div>
            </div>

            <Popover.Panel className="lg:hidden">
              <div className="px-2 pt-2 pb-3 space-y-1">
                {navigation.map((item) => (
                  <Disclosure
                    key={item.name}
                    as="div"
                    className="border-b border-gray-200"
                  >
                    {({ open }) => (
                      <>
                        <Disclosure.Button className="w-full flex items-center justify-between py-2 px-3 text-base font-medium text-gray-600 hover:bg-gray-50">
                          <span>{item.name}</span>
                          {item.submenu && (
                            <ChevronDownIcon
                              className={classNames(
                                open ? "rotate-180" : "",
                                "w-5 h-5 text-gray-500"
                              )}
                            />
                          )}
                        </Disclosure.Button>
                        {item.submenu && (
                          <Disclosure.Panel className="space-y-1">
                            {item.submenu.map((subitem) => (
                              <NavLink
                                key={subitem.name}
                                to={subitem.href}
                                className="block pl-8 py-2 text-gray-500 hover:bg-gray-50"
                              >
                                {subitem.name}
                              </NavLink>
                            ))}
                          </Disclosure.Panel>
                        )}
                      </>
                    )}
                  </Disclosure>
                ))}
              </div>
              <div className="px-2 py-2 justify-center">
                <NavLink
                  to="/get-started"
                  className="block px-6 py-3 rounded-full text-white bg-blue-800 hover:bg-blue-900 text-center"
                >
                  Get Started
                </NavLink>
              </div>
            </Popover.Panel>
          </>
        )}
      </Popover>
    </>
  );
}

export default Navbar;
